export default "__VITE_ASSET__JMw$$zYq__"